<!-- 岗位详情页 -->
<template>
  <div class="bg-white">
    <div class="wrapper bg-[#f8f9fd]">
      <div class="container-1000 flex justify-between pb-[30px] pt-[60px]">
        <div>
          <!-- 岗位信息 -->
          <div class="mb-[40px] flex items-center">
            <p class="mr-[10px] text-[24px] text-[#313131]">{{ detail.title }}</p>
          </div>
          <div class="text-[#818181]">
            <span class="mr-[47px]">发布时间：{{ detail.create_time }}</span>
            <span>{{ detail.dd }}</span>
            <el-divider direction="vertical" class="!mx-[15px]"></el-divider>
            <span>{{ detail.recruit_catagory_id }}</span>
            <span class="ml-[83px]">招聘人数：{{ detail.number }}</span>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="flex flex-col items-center">
          <div @click="openDialog" class="flex cursor-pointer items-center">
            <img class="mr-[12px]" :src="$getImageSrc('detail-send.png')" alt="" />
            <span class="text-[#267cde]">立即投递</span>
          </div>
          <div class="mt-[45px] flex items-center">
            <div v-if="isCollect" class="flex cursor-pointer items-center" @click="handleCollect">
              <Icon icon="ant-design:star-filled" class="text-[#fae571]" />
              <span class="text-[14px] text-[#5b5c5e]">已收藏</span>
            </div>
            <div v-else class="flex cursor-pointer items-center" @click="handleCollect">
              <Icon icon="ant-design:star-outlined" class="text-[#b1b2b5]" />
              <span class="text-[14px] text-[#5b5c5e]">收藏</span>
            </div>
            <el-divider direction="vertical" class="!mx-[20px]"></el-divider>
            <div class="flex justify-center text-[20px] text-[#86888a]">
              <div class="group relative">
                <Icon icon="ant-design:wechat-outlined" class="mr-[16px] cursor-pointer" />
                <VueQrcode
                  :value="pageHref ? pageHref : '123'"
                  :options="{ margin: 2, width: 150 }"
                  class="absolute left-[50%] mt-[5px] hidden -translate-x-[50%] shadow group-hover:block"
                ></VueQrcode>
              </div>
              <a :href="shareLink(this.pageHref, this.detail.title).qq" target="_blank">
                <Icon icon="ant-design:qq-outlined" class="mr-[16px] cursor-pointer" />
              </a>
              <a :href="shareLink(this.pageHref, this.detail.title).weibo" target="_blank">
                <Icon icon="ant-design:weibo-outlined" class="mr-[16px] cursor-pointer" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper mt-[32px]">
      <div class="container-1000">
        <div class="detail-content" v-html="detail.content"></div>
      </div>
    </div>
    <el-dialog title="请选择要投递的简历" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div v-if="resumeData.length">
        <div v-for="item in resumeData" :key="item.id">
          <div class="flex items-center justify-between rounded border-b bg-white px-[24px] py-[20px]">
            <div>
              <p class="mb-[5px] text-[18px] font-bold">{{ item.id }}</p>
              <p class="text-[14px] text-[#b3b3b3]">最后更新时间：{{ item.update_time }}</p>
            </div>
            <div>
              <button type="button" class="el-button el-button--default" @click="delivery(item.id)">
                <span>投递此份简历</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <button type="button" class="el-button el-button--default">
          <a href="resume.html" target="_blank" @click="dialogVisible = false">请先新建简历</a>
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { shareLink, openLoginDialogWithMessage } from '@/utils/tool';
import { Icon } from '@iconify/vue2';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { formatDate } from '@/utils/tool';
import { detail, delivery, collectAdd, collectDelete, collectStatus } from '@/api/position';
import { resumeList } from '@/api/user-center';

export default {
  name: 'PosDetail',
  components: {
    Icon,
    VueQrcode,
  },
  data() {
    return {
      id: '', //岗位id
      ids: '', //收藏id
      isCollect: false, // 是否已收藏
      dialogVisible: false, // 投递简历弹窗
      // 投递简历列表
      resumeData: [
        {
          id: '8',
          name: '',
          sex: '',
          birthday: '0',
          mz: '',
          hyzk: '',
          gznx: '',
          zzmm: '',
          zjlx: '',
          zjhm: '',
          province: '',
          province2: '',
          zgxl: '',
          xw: '',
          xl: '',
          bysj: '0',
          byyx: '',
          zy: '',
          yddh: '',
          dayx: '',
          txdz: '',
          yb: '',
          zp: '',
          city: '',
          district: '',
          city2: '',
          district2: '',
          gj: '',
          index_user_id: '1',
          delete_time: '',
          update_time: '',
        },
      ],
      // 岗位详情
      detail: {
        id: '',
        title: '',
        recruit_catagory_id: '',
        dd: '',
        number: '',
        content: '',
        create_time: '',
      },
      // 当前页面链接（用作分享）
      pageHref: '',
    };
  },
  methods: {
    shareLink,
    // 获取岗位详情
    getDetail() {
      detail({ id: this.id })
        .then((res) => {
          this.detail = res.data.map((item) => {
            item.create_time = formatDate(item.create_time, 'YYYY-MM-DD');
            return item;
          })[0];
        })
        .catch((err) => {});
    },
    // 打开投递简历弹窗
    openDialog() {
      if (!this.$store.state.token) {
        this.$message.error('请先登录');
        openLoginDialogWithMessage();
        return;
      }

      this.dialogVisible = true;
      resumeList()
        .then((res) => {
          this.resumeData = res.data.list;
          this.resumeData.map((item) => {
            item.update_time = formatDate(item.update_time, 'YYYY-MM-DD HH:mm:ss');
            return item;
          });
        })
        .catch((err) => {});
    },
    // 关闭投递简历弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 投递简历
    delivery(resume_id) {
      // 岗位id，简历id
      delivery({ recruit_id: this.id, resume_id })
        .then((res) => {
          this.$message.success(res.msg);
          this.handleClose();
        })
        .catch((err) => {});
    },
    // 获取收藏状态
    getIfCollect() {
      if (!this.$store.state.token) return; // 未登录，不请求

      collectStatus(this.id)
        .then((res) => {
          if (res.data) {
            this.isCollect = true;
            this.ids = res.data.id;
          } else {
            this.isCollect = false;
            this.ids = '';
          }
        })
        .catch((err) => {});
    },
    // 收藏岗位
    handleCollect() {
      if (this.isCollect) {
        // 取消收藏
        collectDelete({ ids: this.ids })
          .then((res) => {
            this.isCollect = false;
            this.ids = '';
            this.$message.success('取消收藏成功');
          })
          .catch((err) => {
            this.$message.error(err.msg);
          });
      } else {
        // 收藏
        collectAdd({ recruit_id: this.id })
          .then((res) => {
            this.isCollect = true;
            this.ids = res.data;
            this.$message.success('收藏成功');
          })
          .catch((err) => {});
      }
    },
    // 路由变化
    handleChange() {
      this.id = this.$route.query.id;
      this.pageHref = window.location.href;
      this.getDetail();
      this.getIfCollect();
    },
  },
  mounted() {
    this.handleChange();
  },
  watch: {
    // 监听路由变化
    $route() {
      this.handleChange();
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  &-title {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: bold;
  }
  &-content {
    font-size: 14px;
    line-height: 1.8;
    color: #9c9c9c;
    margin-bottom: 40px;
  }
}
</style>
